import Vue from 'vue';
import SignupApi from '../../api/SignupApi';
import Segment from '../../Segment';
import phoneNumber from '../../utils/phoneNumber';

const inviteMemberFlowSteps = {
  enterDetails: 'enter-details',
  enterCode: 'enter-code',
  done: 'done',
};

const errorTypes = {
  memberAlreadyExists: 'MEMBER_ALREADY_EXISTS',
};

const state = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  currentFlowStep: inviteMemberFlowSteps.enterDetails,
  errors: {
    generateCode: '',
    createMember: '',
  },
};

const getters = {
  inviteMemberFlowSteps: () => inviteMemberFlowSteps,
  errorTypes: () => errorTypes,
};

const actions = {
  async generateCode({ dispatch, state, commit }) {
    if (phoneNumber.validatePhoneNumber(state.phoneNumber)) {
      try {
        await SignupApi.generateCode({ phoneNumber: state.phoneNumber });
      } catch (e) {
        dispatch('catchServerError', { e, functionName: 'generateCode' });
      }
    } else {
      commit('setError', { error: 'INVALID_PHONE_NUMBER', functionName: 'generateCode' });
      throw new Error('Invalid phone number');
    }
  },
  async createMember({ dispatch, state }, code) {
    try {
      await SignupApi.createMemberUsingCode({
        firstName: state.firstName,
        lastName: state.lastName,
        phoneNumber: state.phoneNumber,
        code,
      });
    } catch (e) {
      dispatch('catchServerError', { e, functionName: 'createMember' });
    }
  },
  catchServerError({ commit }, { e, functionName }) {
    if (e.response && e.response.status === 400) {
      commit('setError', { error: e.response.data, functionName });
    } else {
      commit('setError', { error: 'UNKNOWN_ERROR', functionName });
    }
    Segment.trackUserGot('MemberInviteError', { error: e });
    throw e;
  },
};

const mutations = {
  setCurrentFlowStep(state, currentFlowStep) {
    state.currentFlowStep = currentFlowStep; // eslint-disable-line
  },
  setFirstName(state, firstName) {
    state.firstName = firstName; // eslint-disable-line
  },
  setLastName(state, lastName) {
    state.lastName = lastName; // eslint-disable-line
  },
  setPhoneNumber(state, phoneNumber) {
    state.phoneNumber = phoneNumber; // eslint-disable-line
  },
  setError(state, { error, functionName }) {
    Vue.set(state.errors, functionName, error);
  },
  resetError(state, functionName) {
    Vue.set(state.errors, functionName, '');
  },
};


export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/memberInvite.js